import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { ALL_HEALTH_SIGNAL_KINDS, type HealthSignalKind } from '@etiquetachef/types';

export type HealthFiltersProps = {
  selected: readonly HealthSignalKind[];
  onChange: (next: readonly HealthSignalKind[]) => void;
};

/**
 * Botões liga/desliga por sinal de saúde; lista vazia = todos (decidido na
 * `HealthDashboardPage`).
 */
export function HealthFilters({ selected, onChange }: HealthFiltersProps): React.JSX.Element {
  const { t } = useTranslation();
  function toggle(kind: HealthSignalKind): void {
    onChange(selected.includes(kind) ? selected.filter((k) => k !== kind) : [...selected, kind]);
  }
  return (
    <SpaceBetween direction="horizontal" size="xs">
      {ALL_HEALTH_SIGNAL_KINDS.map((kind) => (
        <Button
          key={kind}
          variant={selected.includes(kind) ? 'primary' : 'normal'}
          onClick={(): void => {
            toggle(kind);
          }}
        >
          {t(`health.signal.${kind}`)}
        </Button>
      ))}
    </SpaceBetween>
  );
}
